const LandingFooter = (): JSX.Element => (
    <section className="bg-blue-600 text-white py-12 w-full">
        <div className="flex flex-col items-center text-center">
            <p>Copyright all rights reserved</p>
            <a href="/contact" className="text-white underline">Contact us</a>
        </div>
    </section>
);

export default LandingFooter;
